import React, { useState, useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"

import {
    StoreType,
    setCcCompliancePopupMenuShow,
} from "client/store"
import {
    PopupMenu,
    PopupMenuItem,
} from "client/components"

import Open from "./open"

const Menu = () => {
    const baseRoute = useSelector((state: StoreType) => state.ccCompliance.baseRoute)
    const revisionActiveList = useSelector((state: StoreType) => state.ccCompliance.revisionActiveList)
    const active = useSelector((state: StoreType) => state.ccCompliance.active)
    const menuShow = useSelector((state: StoreType) => state.ccCompliance.menuShow)
    const menuTarget = useSelector((state: StoreType) => state.ccCompliance.menuTarget)

    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [menuItems, setMenuItems] = useState<any[]>([])

    const hideMenu = () => {
        dispatch(setCcCompliancePopupMenuShow(false))
    }

    useEffect(() => {
        document.addEventListener("click", hideMenu)
        return () => document.removeEventListener("click", hideMenu)
    }, [])

    const open = (
        <PopupMenuItem
            key="open"
            onClick={() => {
                if (!active) return
                const revision = revisionActiveList[active.librarySetId]
                if (!revision) return

                Open(active.librarySetId, revision.id, active.id, baseRoute, dispatch)
            }}
        >
            {lang.open}
        </PopupMenuItem>
    )

    useEffect(() => {
        const menu: any[] = []
        menu.push(open)

        setMenuItems(menu)
    }, [active])


    if (!menuItems.length) return null
    return (
        <PopupMenu
            show={menuShow}
            target={menuTarget}
            placement="right"
        >
            {menuItems}
        </PopupMenu>
    )
}

export default Menu
